import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "./components/SideBar/sideBar";
import { SidebarProvider } from "./SidebarContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./components/locale/i18n";
import ProtectedRoute from "./ProtectedRoute";
import Cookies from "js-cookie";

import Login from "./pages/login/Login";
import Signup from "./pages/signup/page";
import ClientsPage from "./pages/clients/page";
import EditClient from "./pages/clients/client/[client_id]/page";
import TenantEmployeesPage from "./pages/employees/page";
import ComplexServices from "./pages/services/complex/page";
import RegularServices from "./pages/services/regular/page";
import CarsPage from "./pages/cars/page";
import CarDetail from "./pages/cars/[car_id]/page";
import WorkOrdersPage from "./pages/workOrders/page";
import AddWorkOrder from "./pages/workOrders/add/page";
import WorkOrderDetails from "./pages/workOrders/[work_order_id]/page";
import CalendarViewSelector from "./pages/Calendar/Calendar";
import Dashboard from "./pages/Dashboard/dashboard";

const App = () => {
  return (
    <SidebarProvider> 
      <I18nextProvider i18n={i18n}>
        <Router>
          <AppContent />
        </Router>
      </I18nextProvider>
    </SidebarProvider>
  );
};

const AppContent = () => {
  const location = useLocation(); 
  const hideSidebarRoutes = ["/login", "/signup"];
  const isAuthenticated = !!Cookies.get("access_token"); 

  return (
    <div style={{ display: "flex", height:"100vh", overflowY:"hidden", background:"#F5F5F5"}}>
      {isAuthenticated && !hideSidebarRoutes.includes(location.pathname) && <Sidebar />}
      <div style={{ flex: 1, overflowY:"scroll" }}>
        <main style={{ padding: "0 1%" }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/clients" element={<ClientsPage />} />
              <Route path="/clients/client/:client_id" element={<EditClient />} />
              <Route path="/employees" element={<TenantEmployeesPage />} />
              <Route path="/services/complex" element={<ComplexServices />} />
              <Route path="/services/regular" element={<RegularServices />} />
              <Route path="/cars" element={<CarsPage />} />
              <Route path="/cars/:car_id" element={<CarDetail />} />
              <Route path="/workOrders/:work_order_id" element={<WorkOrderDetails />} />
              <Route path="/calendar" element={<CalendarViewSelector />} />
              <Route path="/workOrders/add" element={<AddWorkOrder />} />
              <Route path="/workOrders" element={<WorkOrdersPage />} />
              <Route path="/dashboard" element={<Dashboard/>} />
              <Route path="/" element={<><Dashboard/></>} />
              <Route path="*" element={<>404</>} />

            </Route>

          </Routes>
        </main>
      </div>
    </div>
  );
};

export default App;
